(function () {
  var SELECTOR = 'form[data-ha-newsletter-ajax], form.ha-newsletter__form, form.ha-newsletter-popup__form';
  var DEBUG =
    /(?:^|[?&])ha_nl_debug=1(?:&|$)/.test(window.location.search) ||
    window.localStorage.getItem('ha_nl_debug') === '1';

  function log() {
    if (!DEBUG || typeof console === 'undefined' || !console.log) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[ha-newsletter]');
    console.log.apply(console, args);
  }

  function isAjaxForm(form) {
    return form && form.matches && form.matches(SELECTOR);
  }

  function isPopupForm(form) {
    return form.id === 'ha-newsletter-popup-form' || form.classList.contains('ha-newsletter-popup__form');
  }

  function registerForms() {
    document.querySelectorAll(SELECTOR).forEach(function (form) {
      if (!form.hasAttribute('data-ha-newsletter-ajax')) {
        form.setAttribute('data-ha-newsletter-ajax', 'true');
      }
      bindForm(form);
    });
    log('forms registered', document.querySelectorAll(SELECTOR).length);
  }

  function bindForm(form) {
    if (!form || !isAjaxForm(form) || form.dataset.haNewsletterBound === 'true') return;
    form.dataset.haNewsletterBound = 'true';

    form.addEventListener('input', function (event) {
      var target = event.target;
      if (target && target.classList) {
        target.classList.remove('ha-newsletter-field--invalid');
      }
    });

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        submitForm(form);
      },
      true
    );

    log('bound', form.id || form.className);
  }

  function getFormSubmitUrl(form) {
    var action = form && form.getAttribute('action');
    if (action) {
      return action.split('#')[0];
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      var root = window.Shopify.routes.root;
      return root + (root.endsWith('/') ? '' : '/') + 'contact';
    }

    return '/contact';
  }

  function appendNewsletterSuccessParam(url, paramName) {
    if (!url) return url;
    paramName = paramName || 'ha_newsletter_success';

    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set(paramName, '1');
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      var separator = url.indexOf('?') >= 0 ? '&' : '?';
      return url + separator + paramName + '=1';
    }
  }

  function buildUrlEncodedBody(form) {
    var data = new FormData(form);

    if (!data.get('form_type')) {
      data.set('form_type', 'customer');
    }

    if (!data.get('utf8')) {
      data.set('utf8', '✓');
    }

    var popup = form.closest('#ha-newsletter-popup');
    var returnTo = data.get('return_to');

    if (!returnTo) {
      returnTo = popup && popup.getAttribute('data-ha-np-return-to');
      if (!returnTo) {
        returnTo = appendNewsletterSuccessParam(window.location.pathname + window.location.search);
      }
      data.set('return_to', returnTo);
    }

    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      params.append(key, value);
    });

    log('payload return_to', params.get('return_to'));
    return params;
  }

  function clearInvalidMarks(form) {
    form.querySelectorAll('.ha-newsletter-field--invalid').forEach(function (field) {
      field.classList.remove('ha-newsletter-field--invalid');
    });
  }

  function getFieldValidationMessage(field) {
    var label = field.getAttribute('aria-label') || field.name || 'Ce champ';

    if (field.validity.valueMissing) {
      return 'Veuillez renseigner le champ « ' + label + ' ».';
    }

    if (field.type === 'email' && field.validity.typeMismatch) {
      return 'Veuillez saisir une adresse e-mail valide.';
    }

    return 'Le champ « ' + label + ' » est invalide.';
  }

  function validateFormFields(form) {
    clearFeedback(form);
    clearInvalidMarks(form);

    var fields = form.querySelectorAll('[data-ha-newsletter-fields] input, [data-ha-newsletter-fields] textarea');
    var errors = [];
    var firstInvalidField = null;

    fields.forEach(function (field) {
      if (!field.willValidate) return;

      field.setCustomValidity('');

      if (!field.checkValidity()) {
        field.classList.add('ha-newsletter-field--invalid');

        if (!firstInvalidField) {
          firstInvalidField = field;
        }

        errors.push(getFieldValidationMessage(field));
      }
    });

    if (errors.length) {
      showError(form, '<ul><li>' + errors.join('</li><li>') + '</li></ul>');

      if (firstInvalidField) {
        firstInvalidField.focus();
      }

      return false;
    }

    return true;
  }

  function getErrorClass(form) {
    return isPopupForm(form) ? 'ha-newsletter-popup__error' : 'ha-newsletter__error';
  }

  function clearFeedback(form) {
    form.querySelectorAll('[data-ha-newsletter-error]').forEach(function (el) {
      el.remove();
    });
  }

  function showError(form, message) {
    clearFeedback(form);
    var el = document.createElement('div');
    el.setAttribute('data-ha-newsletter-error', '');
    el.className = getErrorClass(form);
    el.innerHTML = message;
    var anchor = form.querySelector('[data-ha-newsletter-fields]') || form.querySelector('[data-ha-newsletter-legal]');
    if (anchor) {
      anchor.before(el);
    } else {
      form.appendChild(el);
    }
  }

  function applyPopupSuccessState(form) {
    var popup = form.closest('#ha-newsletter-popup');
    var content = form.closest('.ha-newsletter-popup__content');
    var textBlock = content && content.querySelector('.ha-newsletter-popup__text');

    if (textBlock) {
      textBlock.hidden = true;
    }

    form.querySelectorAll('[data-ha-newsletter-legal]').forEach(function (el) {
      el.hidden = true;
    });

    if (popup) {
      popup.classList.add('ha-newsletter-popup--success-only', 'active');
      document.body.classList.add('NewsletterActive', 'scrollHidden');
    }
  }

  function setClosedCookie() {
    if (typeof Cookies === 'undefined') return;
    var date = new Date();
    date.setTime(date.getTime() + 10 * 24 * 60 * 60 * 1000);
    Cookies.set('Newsletter_closed', 'Newsletter_closed_val', { expires: date, path: '/' });
  }

  function openSuccessOverlay() {
    var popup = document.getElementById('ha-newsletter-popup');
    if (!popup) {
      log('no popup element for overlay');
      return false;
    }

    if (popup.getAttribute('data-ha-np-success-overlay-enable') !== 'true') {
      log('success overlay disabled in settings');
      return false;
    }

    if (window.HaNewsletterPopup && typeof window.HaNewsletterPopup.showSuccess === 'function') {
      window.HaNewsletterPopup.showSuccess();
      log('HaNewsletterPopup.showSuccess() called');
      return true;
    }

    log('HaNewsletterPopup.showSuccess missing — fallback open');
    popup.classList.add('active', 'ha-newsletter-popup--success-only');
    document.body.classList.add('NewsletterActive', 'scrollHidden');
    return true;
  }

  function showSuccess(form) {
    clearFeedback(form);
    form.querySelectorAll('[data-ha-newsletter-success]').forEach(function (el) {
      if (!el.closest('template')) el.remove();
    });

    var template = form.querySelector('[data-ha-newsletter-success-template]');
    var fields = form.querySelector('[data-ha-newsletter-fields]');

    if (template && template.content) {
      form.insertBefore(template.content.cloneNode(true), template);
    }

    if (fields) {
      fields.hidden = true;
    }

    form.classList.add('ha-newsletter-form--submitted');
    localStorage.setItem('theme:popup-filled', 'true');
    setClosedCookie();

    if (isPopupForm(form)) {
      applyPopupSuccessState(form);
      log('popup form success applied');
      return;
    }

    openSuccessOverlay();
  }

  function responseUrlIndicatesSuccess(url) {
    if (!url) return false;
    var lower = url.toLowerCase();
    return (
      lower.indexOf('customer_posted=true') !== -1 ||
      lower.indexOf('ha_newsletter_success=1') !== -1 ||
      lower.indexOf('ha_np=1') !== -1
    );
  }

  function isChallengeUrl(url) {
    return !!(url && url.toLowerCase().indexOf('/challenge') !== -1);
  }

  function looksLikeChallenge(html) {
    return /shopify-challenge__container|name=["']captcha["']|g-recaptcha|h-captcha/i.test(html || '');
  }

  function getVisibleSuccessEl(root, formId) {
    var popup = root.getElementById('ha-newsletter-popup');
    if (popup && popup.getAttribute('data-ha-np-submitted') === 'true') {
      return popup.querySelector('[data-ha-newsletter-success]');
    }

    var returnedForm = formId ? root.getElementById(formId) : null;
    if (!returnedForm) return null;

    var directSuccess = returnedForm.querySelector(':scope > [data-ha-newsletter-success]');
    if (directSuccess && directSuccess.textContent.trim()) {
      return directSuccess;
    }

    return null;
  }

  function getFormErrorHtml(root, formId) {
    var popup = root.getElementById('ha-newsletter-popup');
    if (popup && popup.getAttribute('data-ha-np-error') === 'true') {
      var popupError = popup.querySelector('[data-ha-newsletter-error], .ha-newsletter-popup__error, .errors');
      if (popupError && popupError.textContent.trim()) {
        return popupError.innerHTML;
      }
    }

    var returnedForm = formId ? root.getElementById(formId) : null;
    if (returnedForm) {
      var formError = returnedForm.querySelector('[data-ha-newsletter-error], .errors');
      if (formError && formError.textContent.trim()) {
        return formError.innerHTML;
      }
    }

    var globalError = root.querySelector(
      '#ha-newsletter-popup-form .errors, #contact_form .errors, .form-message--error, .errors'
    );
    if (globalError && globalError.textContent.trim()) {
      // Ignore unrelated page errors far from newsletter forms.
      if (
        globalError.closest('#ha-newsletter-popup-form') ||
        globalError.closest('.ha-newsletter__form') ||
        globalError.closest('#contact_form') ||
        (formId && globalError.closest('#' + formId))
      ) {
        return globalError.innerHTML;
      }
    }

    return '';
  }

  function parseResponse(html, form, responseMeta) {
    if (responseMeta && isChallengeUrl(responseMeta.url)) {
      return { success: false, challenge: true, errorHtml: '' };
    }

    if (responseMeta && responseUrlIndicatesSuccess(responseMeta.url)) {
      return { success: true, reason: 'url' };
    }

    if (looksLikeChallenge(html)) {
      return { success: false, challenge: true, errorHtml: '' };
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var formId = form.id;
    var errorHtml = getFormErrorHtml(doc, formId);

    if (errorHtml) {
      return { success: false, errorHtml: errorHtml, reason: 'error-html' };
    }

    if (getVisibleSuccessEl(doc, formId)) {
      return { success: true, reason: 'success-el' };
    }

    // Shopify often returns 200 after a successful customer/newsletter create
    // without reliable Liquid success markers when overlay mode hides inline messages.
    if (responseMeta && responseMeta.ok && (responseMeta.redirected || responseMeta.status === 200)) {
      if (/already been taken|has already subscribed|invalid email|is invalid/i.test(html)) {
        return {
          success: false,
          errorHtml: 'Impossible de confirmer votre inscription. Vérifiez vos informations.',
          reason: 'keyword-error',
        };
      }

      return { success: true, reason: 'ok-no-error' };
    }

    return {
      success: false,
      errorHtml: 'Impossible de confirmer votre inscription. Veuillez réessayer.',
      reason: 'fallback-fail',
    };
  }

  function setLoading(form, isLoading) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.disabled = isLoading;
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function submitNativeReload(form) {
    form.removeAttribute('target');
    form.removeAttribute('data-ha-newsletter-ajax');
    form.dataset.haNewsletterSubmitting = 'false';
    setLoading(form, false);
    form.submit();
  }

  function submitForm(form) {
    if (form.dataset.haNewsletterSubmitting === 'true') return;

    if (!validateFormFields(form)) {
      return;
    }

    form.dataset.haNewsletterSubmitting = 'true';
    clearFeedback(form);
    setLoading(form, true);
    log('submit', form.id || form.className, getFormSubmitUrl(form));

    fetch(getFormSubmitUrl(form), {
      method: 'POST',
      body: buildUrlEncodedBody(form),
      credentials: 'same-origin',
      redirect: 'follow',
      headers: {
        Accept: 'text/html,application/xhtml+xml',
      },
    })
      .then(function (response) {
        return response.text().then(function (html) {
          return {
            ok: response.ok,
            status: response.status,
            html: html,
            url: response.url,
            redirected: response.redirected,
          };
        });
      })
      .then(function (payload) {
        log('response', {
          ok: payload.ok,
          status: payload.status,
          redirected: payload.redirected,
          url: payload.url,
        });

        if (isChallengeUrl(payload.url) || looksLikeChallenge(payload.html)) {
          log('challenge detected — native reload');
          submitNativeReload(form);
          return;
        }

        if (responseUrlIndicatesSuccess(payload.url)) {
          log('success via url');
          showSuccess(form);
          return;
        }

        if (payload.status === 400) {
          log('status 400 — native reload');
          submitNativeReload(form);
          return;
        }

        if (!payload.ok) {
          showError(form, 'Impossible de confirmer votre inscription. Veuillez réessayer.');
          return;
        }

        var result = parseResponse(payload.html, form, payload);
        log('parseResult', result);

        if (result.challenge) {
          submitNativeReload(form);
          return;
        }

        if (result.success) {
          showSuccess(form);
        } else {
          showError(form, result.errorHtml || 'Impossible de confirmer votre inscription. Veuillez réessayer.');
        }
      })
      .catch(function (error) {
        log('network error', error);
        showError(form, 'Erreur réseau. Veuillez réessayer.');
      })
      .finally(function () {
        if (form.dataset.haNewsletterSubmitting === 'true') {
          form.dataset.haNewsletterSubmitting = 'false';
          setLoading(form, false);
        }
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM' || !isAjaxForm(form)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitForm(form);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', registerForms);
  document.addEventListener('shopify:section:load', registerForms);
  registerForms();

  window.HaNewsletterForm = {
    register: bindForm,
    submit: submitForm,
    debug: function (enabled) {
      if (enabled === false) {
        window.localStorage.removeItem('ha_nl_debug');
      } else {
        window.localStorage.setItem('ha_nl_debug', '1');
      }
      return window.localStorage.getItem('ha_nl_debug') === '1';
    },
  };

  log('script loaded', { debug: DEBUG });
})();
